import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import dummy from "../../../../Assets/images/dummy.jpg";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import MenuApi from "../../../../App/api/menu.apis";
import selectDropdown from "../../../../custom/SelectDropdown";
import { Formik, ErrorMessage, Form } from "formik";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Button from "../../../../Components/Button";
import SidebarField from "../../../../Components/SidebarField";
import TextInput from "../../../../Components/TextInput";
import { FormField } from "../../../../Components/FormField";
import { UsersApi } from "../../../../App/api/users.api";
import AuthApi from "../../../../App/api/auth.apis";
import { RegionMasterApi } from "../../../../App/api/RegionMaster";
import { validationSchema } from "./ValidationSchema";

function AddUserDetail({ currentItems, getAllData, open, handleClose }) {
  const [regionOptions, setRegionOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [imagePreview, setImagePreview] = useState(dummy);
  const fileInputRef = useRef(null);
  const [emailOtp, setEmailOtp] = useState("");
  const [phoneOtp, setPhoneOtp] = useState("");
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [phoneOtpSent, setPhoneOtpSent] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [sendingEmailOtp, setSendingEmailOtp] = useState(false);
  const [verifyingEmailOtp, setVerifyingEmailOtp] = useState(false);
  const [sendingPhoneOtp, setSendingPhoneOtp] = useState(false);
  const [verifyingPhoneOtp, setVerifyingPhoneOtp] = useState(false);

  // Fetch country list
  const { value: countryList } = useFetchAll(() => MenuApi.getAllCountry());
  const countryOptions = selectDropdown(countryList?.data, "_id", "name");

  // Fetch user roles
  const { value: userRoleList } = useFetchAll(() => UsersApi.getUserRole());
  const userRoleOptions = selectDropdown(userRoleList?.data, "role_id", "name");


  // Validation schema

  // Handle image upload
  const handleImageUpload = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      setFieldValue("profile_image", file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // Trigger file input
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const resetVerificationState = () => {
    setEmailOtp("");
    setPhoneOtp("");
    setEmailOtpSent(false);
    setPhoneOtpSent(false);
    setEmailVerified(false);
    setPhoneVerified(false);
    setSendingEmailOtp(false);
    setVerifyingEmailOtp(false);
    setSendingPhoneOtp(false);
    setVerifyingPhoneOtp(false);
  };

  useEffect(() => {
    if (open) {
      resetVerificationState();
    }
  }, [open]);

  // Handle country change and fetch cities
  const handleCountryChange = async (selected, setFieldValue) => {
    setFieldValue("country", selected);
    if (selected?.value) {
      try {
        const res = await MenuApi.getAllCity(selected.value);
        // console.log('res?.data?.data',res?.data?.data);

        setCityOptions(res?.data?.data);
        // console.log("city payload response :", res?.data?.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
        toast.error("Failed to load cities.");
      }
    }
  };

  // // Handle city change and fetch regions
  // const handleCityChange = async (selected, setFieldValue) => {
  //   setSelectedCity(selected);
  //   setFieldValue("city", selected);
  //   console.log("selected city payload :", selected);

  //     try {
  //       const res = await RegionMasterApi.getAllRegionData();
  //       setRegionOptions(selectDropdown(res?.data?.data, "_id", "name"));
  //       setSelectedRegion(selected.value);
  //       console.log("region payload response :", res?.data?.data);
  //     } catch (error) {
  //       // console.error("Error fetching regions:", error);
  //       toast.warning("No regions found for the selected city.", error);
  //     }

  // };

  const handleSendEmailOtp = async (email) => {
    if (!email) {
      toast.warning("Enter email before sending OTP.");
      return;
    }

    try {
      setSendingEmailOtp(true);
      await AuthApi.sendEmailOtp({ email });
      setEmailOtpSent(true);
      setEmailVerified(false);
      toast.success("Email OTP sent successfully.");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to send email OTP.");
    } finally {
      setSendingEmailOtp(false);
    }
  };

  const handleVerifyEmailOtp = async (email) => {
    if (!email) {
      toast.warning("Enter email before verifying OTP.");
      return;
    }

    if (!emailOtp) {
      toast.warning("Enter email OTP.");
      return;
    }

    try {
      setVerifyingEmailOtp(true);
      await AuthApi.verifyEmailOtp({ email, otp: emailOtp });
      setEmailVerified(true);
      toast.success("Email verified successfully.");
    } catch (error) {
      setEmailVerified(false);
      toast.error(
        error?.response?.data?.message || "Failed to verify email OTP."
      );
    } finally {
      setVerifyingEmailOtp(false);
    }
  };

  const handleSendPhoneOtp = async (phone_number) => {
    if (!phone_number) {
      toast.warning("Enter phone number before sending OTP.");
      return;
    }

    try {
      setSendingPhoneOtp(true);
      await AuthApi.sendPhoneOtp({ phone_number });
      setPhoneOtpSent(true);
      setPhoneVerified(false);
      toast.success("Phone OTP sent successfully.");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to send phone OTP.");
    } finally {
      setSendingPhoneOtp(false);
    }
  };

  const handleVerifyPhoneOtp = async (phone_number) => {
    if (!phone_number) {
      toast.warning("Enter phone number before verifying OTP.");
      return;
    }

    if (!phoneOtp) {
      toast.warning("Enter phone OTP.");
      return;
    }

    try {
      setVerifyingPhoneOtp(true);
      await AuthApi.verifyPhoneOtp({ phone_number, otp: phoneOtp });
      setPhoneVerified(true);
      toast.success("Phone verified successfully.");
    } catch (error) {
      setPhoneVerified(false);
      toast.error(
        error?.response?.data?.message || "Failed to verify phone OTP."
      );
    } finally {
      setVerifyingPhoneOtp(false);
    }
  };

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    // console.log("Form Data Captured:", values);
    // toast.success("Form Data Captured successfully!");
    if (!currentItems?._id && !emailVerified && !phoneVerified) {
      toast.warning("Verify either email or phone number before submitting.");
      setSubmitting(false);
      return;
    }

    const payload = {
      ...values,
      country: values.country.value,
      city: values.city.value,
      user_role: values?.user_role?.value,
    };
    // console.log("User added payload :", payload);

    try {
      // Send form values directly as payload to the API
      const response = await AuthApi.register(payload);
      console.log("User added response:", response);

      setSubmitting(false);
      resetForm();
      resetVerificationState();
      getAllData();
      handleClose();
      setImagePreview(dummy);
      fileInputRef.current.value = null;
      toast.success("User added successfully!");
    } catch (error) {
      console.error("Error creating user", error);
      toast.warning(error);
      setSubmitting(false);
    }
  };

  if (open) {
    console.log("open", open);

    return (
      <Formik
        initialValues={{
          first_name: currentItems?.first_name || "",
          last_name: currentItems?.last_name || "",
          phone_number: currentItems?.phone_number || "",
          email: currentItems?.email || "",
          password: currentItems?.password || "",
          confirm_password: currentItems?.confirm_password || "",
          country: currentItems?.country._id
            ? {
                value: currentItems?.country?._id,
                label: currentItems?.country?.name,
                ...currentItems?.country,
              }
            : null,
          city: currentItems?.city._id
            ? {
                value: currentItems?.city?._id,
                label: currentItems?.city?.name,
                ...currentItems?.city,
              }
            : null,
          region: currentItems?.region?._id || null,
          address: currentItems?.address || "",
          profile_image: currentItems?.profile_image || "",
          user_role: currentItems?.user_role._id
            ? {
                value: currentItems?.user_role?._id,
                label: currentItems?.user_role?.name,
                ...currentItems?.user_role,
              }
            : null,
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ handleChange, setFieldValue, values, isSubmitting, isValid }) => (
          <Form
            className="w-full gap-4 flex flex-col bg-transparent py-5 px-3"
            autoComplete="off"
          >
            <SidebarField
              handleClose={handleClose}
              title={currentItems?._id ? `Update User` : `Add New User`}
              button1={
                <Button text="Cancel" type="button" onClick={handleClose} />
              }
              button2={
                <Button
                  text={currentItems?._id ? "Update" : "Submit"}
                  type="submit"
                  disable={!isValid || isSubmitting}
                />
              }
            >
              <div className="flex gap-8">
                <div className="w-[6rem] h-[6rem] justify-between ml-15px">
                  <LazyLoadImage
                    loading="lazy"
                    effect="blur"
                    src={imagePreview}
                    alt="Profile"
                    className="rounded-lg mt-5 h-20 w-30"
                    onClick={triggerFileInput}
                  />
                  <input
                    ref={fileInputRef}
                    type="file"
                    className="hidden"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, setFieldValue)}
                  />
                  <ErrorMessage
                    name="profile_image"
                    component="div"
                    className="text-red-500"
                  />
                </div>

                <div>
                  <FormField label="First Name" tooltip="Enter First Name">
                    <TextInput
                      name="first_name"
                      type="text"
                      value={values.first_name}
                      placeholder="First Name"
                      onChange={handleChange}
                      className="outline-none capitalize"
                    />
                    <ErrorMessage
                      name="first_name"
                      component="p"
                      className="error"
                    />
                  </FormField>

                  <FormField label="Last Name" tooltip="Enter Last Name">
                    <TextInput
                      name="last_name"
                      type="text"
                      value={values.last_name}
                      placeholder="Last Name"
                      className="outline-none capitalize"
                      onChange={(e) =>
                        setFieldValue("last_name", e.target.value)
                      }
                    />
                    <ErrorMessage
                      name="last_name"
                      component="p"
                      className="error"
                    />
                  </FormField>
                </div>
              </div>

              <FormField label="User Role" tooltip="Select a User Role">
                <Select
                  instanceId="roles-add-user-role"
                  inputId="roles-add-user-role"
                  name="roles_add_user_role"
                  value={values.user_role}
                  options={userRoleOptions}
                  placeholder="Select User Role"
                  autoComplete="new-password"
                  onChange={(selected) => {
                    console.log(selected);

                    setFieldValue("user_role", selected);
                  }}
                />
                <ErrorMessage
                  name="user_role"
                  component="p"
                  className="error"
                />
              </FormField>

              <FormField
                label="Phone Number"
                tooltip="Enter Phone Number. Verify either phone number or email before registering."
              >
                <div className="flex items-start gap-2">
                  <div className="flex-1">
                    <TextInput
                      name="phone_number"
                      type="tel"
                      value={values.phone_number}
                      placeholder="Enter Phone Number"
                      className="outline-none"
                      onChange={(e) => {
                        setFieldValue("phone_number", e.target.value);
                        setPhoneVerified(false);
                        setPhoneOtpSent(false);
                        setPhoneOtp("");
                      }}
                    />
                  </div>
                  {!currentItems?._id && (
                    <Button
                      type="button"
                      text={sendingPhoneOtp ? "Sending..." : "Send Phone OTP"}
                      onClick={() => handleSendPhoneOtp(values.phone_number)}
                      disable={sendingPhoneOtp || !values.phone_number}
                      cssClass="px-4 py-2 whitespace-nowrap"
                    />
                  )}
                </div>
                <ErrorMessage
                  name="phone_number"
                  component="p"
                  className="error"
                />
                {!currentItems?._id && (
                  <>
                    {phoneVerified && (
                      <p className="mt-2 text-sm text-green-600">
                        Phone verified
                      </p>
                    )}
                    {phoneOtpSent && !phoneVerified && (
                      <div className="mt-2 flex items-start gap-2">
                        <div className="flex-1">
                          <TextInput
                            name="phoneOtp"
                            type="text"
                            value={phoneOtp}
                            placeholder="Enter phone OTP"
                            className="outline-none"
                            onChange={(e) => setPhoneOtp(e.target.value)}
                          />
                        </div>
                        <Button
                          type="button"
                          text={
                            verifyingPhoneOtp
                              ? "Verifying..."
                              : "Verify Phone OTP"
                          }
                          onClick={() => handleVerifyPhoneOtp(values.phone_number)}
                          disable={verifyingPhoneOtp || !phoneOtp}
                          cssClass="px-4 py-2 whitespace-nowrap"
                        />
                      </div>
                    )}
                  </>
                )}
              </FormField>

              <FormField
                label="Email"
                tooltip="Enter Email Address. Verify either email or phone number before registering."
              >
                <div className="flex items-start gap-2">
                  <div className="flex-1">
                    <TextInput
                      name="email"
                      type="email"
                      value={values.email}
                      placeholder="Enter Your Email"
                      className="outline-none"
                      onChange={(e) => {
                        setFieldValue("email", e.target.value);
                        setEmailVerified(false);
                        setEmailOtpSent(false);
                        setEmailOtp("");
                      }}
                    />
                  </div>
                  {!currentItems?._id && (
                    <Button
                      type="button"
                      text={sendingEmailOtp ? "Sending..." : "Send Email OTP"}
                      onClick={() => handleSendEmailOtp(values.email)}
                      disable={sendingEmailOtp || !values.email}
                      cssClass="px-4 py-2 whitespace-nowrap"
                    />
                  )}
                </div>
                <ErrorMessage name="email" component="p" className="error" />
                {!currentItems?._id && (
                  <>
                    {emailVerified && (
                      <p className="mt-2 text-sm text-green-600">
                        Email verified
                      </p>
                    )}
                    {emailOtpSent && !emailVerified && (
                      <div className="mt-2 flex items-start gap-2">
                        <div className="flex-1">
                          <TextInput
                            name="emailOtp"
                            type="text"
                            value={emailOtp}
                            placeholder="Enter email OTP"
                            className="outline-none"
                            onChange={(e) => setEmailOtp(e.target.value)}
                          />
                        </div>
                        <Button
                          type="button"
                          text={
                            verifyingEmailOtp
                              ? "Verifying..."
                              : "Verify Email OTP"
                          }
                          onClick={() => handleVerifyEmailOtp(values.email)}
                          disable={verifyingEmailOtp || !emailOtp}
                          cssClass="px-4 py-2 whitespace-nowrap"
                        />
                      </div>
                    )}
                  </>
                )}
              </FormField>

              {!currentItems?._id ? (
                <>
                  <FormField label="Password" tooltip="Enter Password">
                    <TextInput
                      name="password"
                      type="password"
                      value={values.password}
                      placeholder="Enter Password"
                      className="outline-none"
                      onChange={(e) =>
                        setFieldValue("password", e.target.value)
                      }
                    />
                    <ErrorMessage
                      name="password"
                      component="p"
                      className="error"
                    />
                  </FormField>

                  <FormField
                    label="Confirm Password"
                    tooltip="Confirm Password"
                  >
                    <TextInput
                      name="confirm_password"
                      type="password"
                      value={values.confirm_password}
                      placeholder="Confirm Password"
                      className="outline-none"
                      onChange={(e) =>
                        setFieldValue("confirm_password", e.target.value)
                      }
                      onPaste={(e) => e.preventDefault()}
                    />
                    <ErrorMessage
                      name="confirm_password"
                      component="p"
                      className="error"
                    />
                  </FormField>
                </>
              ) : (
                ""
              )}

              <FormField label="Select Country" tooltip="Select a Country">
                <Select
                  instanceId="roles-add-user-country"
                  inputId="roles-add-user-country"
                  name="roles_add_user_country"
                  value={values.country}
                  options={countryOptions}
                  placeholder="Select Country"
                  autoComplete="new-password"
                  onChange={(selected) => {
                    handleCountryChange(selected, setFieldValue);
                  }}
                />
                <ErrorMessage name="country" component="p" className="error" />
              </FormField>

              <FormField label="Select City" tooltip="Select a City">
                <Select
                  instanceId="roles-add-user-city"
                  inputId="roles-add-user-city"
                  name="roles_add_user_city"
                  value={values.city}
                  options={selectDropdown(cityOptions, "_id", "name") || []}
                  placeholder="Select City"
                  autoComplete="new-password"
                  onChange={(selected) => setFieldValue("city", selected)}
                  isDisabled={!values.country}
                />
                <ErrorMessage name="city" component="p" className="error" />
              </FormField>

              <FormField label="Select Region" tooltip="Select a Region">
                <Select
                  instanceId="roles-add-user-region"
                  inputId="roles-add-user-region"
                  name="roles_add_user_region"
                  value={values.region}
                  options={regionOptions}
                  placeholder="Select Region"
                  autoComplete="new-password"
                  onChange={(selected) => setFieldValue("region", selected)}
                />
                <ErrorMessage name="region" component="p" className="error" />
              </FormField>

              <FormField label="Address" tooltip="Enter Address">
                <TextInput
                  name="address"
                  type="text"
                  value={values.address}
                  placeholder="Enter Address"
                  className="outline-none"
                  onChange={(e) => setFieldValue("address", e.target.value)}
                />
                <ErrorMessage name="address" component="p" className="error" />
              </FormField>
            </SidebarField>
          </Form>
        )}
      </Formik>
    );
  }
  return null;
}

export default AddUserDetail;
